module.exports = __webpack_public_path__ + "media/images/left-arrow-button-white-fa7046e43390aad8ec06e16724de620f.svg";